export default __webpack_public_path__ + "static/media/loop.e5a9fc36.mp3";